// 🧿 طلسم محافظ فایل

// Types
import {
  IMinProfit,
  IOrderbooksBody,
  IEnterPairPositionSearchParams,
  IEnterPairPositionTableReport,
  IOptionDomainSearchParam,
  OptionDomainReport,
  IOptionDomainConfigDto,
  IEditOrAddOptionDomain,
  IRollSearchParam,
  RollReport,
  IRollConfigDto,
  IPairConfigDto,
  AccountsReport,
  IAccountsSearchParam,
  IFilterParams,
  IConversionConfig,
  IChartData,
  IProfileRisk,
  ProfileRiskReport,
  IAddUserSearchParams,
  IProfileRiskSearchParams,
  ICoveredCallOffsetTableReport,
  IRollFilterParams,
  IOffsetFilterParams,
  IGainAfterCommissionDaily,
  IChartCommonSearchParam,
  ICoveredCallBuyingPowerGraphParams,
  IDailyChartSearchParams,
  IFixedBasePriceConfig,
} from "src/Interfaces/coveredCall";
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { Report } from "src/Interfaces/TableInterfaces";
import { Packet } from "src/Interfaces/commonDtos";
// Utilities
import {
  getRequest,
  getTable,
  postDownloadExcel,
  postRequest,
  putRequest,
  deleteRequest,
} from "./requestTemplates";
import { AxiosRequestConfig } from "axios";

//--------------------جفت پوزیشن ورود---------------------

/**
 *  Covered Call => EnterPairPosition
 * نمودار کانورژن
 *
 * @param {IConversionConfig} input
 * @async
 * @version 1.4.0
 */
export const getConversionGraph = (
  input: IConversionConfig,
): Promise<IChartData[]> =>
  postRequest("/v1/coveredcall/conversionGraph", input);

/**
 * Covered Call
 * دانلود فایل اکسل جفت پوزیشن
 *
 * @param {IEnterPairPositionSearchParams} data
 * @async
 * @version 1.4.0
 */
export const getPaiPositionExcel = (
  searchParam: IEnterPairPositionSearchParams,
) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/coveredCallPairPositionTableExcel?${rand}`,
    searchParam,
  );
};

/**
 * Covered Call
 * جدول جفت پوزیشن ورود
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getEnterPairPositionTable = (
  searchParam: IEnterPairPositionSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<IEnterPairPositionTableReport>> =>
  getTable<IEnterPairPositionSearchParams, IEnterPairPositionTableReport>(
    "/v1/coveredcall/coveredCallPairPositionTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

export const getFixedBasePriceConfig = (): Promise<IFixedBasePriceConfig> =>
  getRequest("/v1/coveredcall/fixedBasePrice/getConfig");

export const setFixedBasePriceConfig = (
  config: IFixedBasePriceConfig,
): Promise<Packet<boolean>> =>
  putRequest("/v1/coveredcall/fixedBasePrice/setConfig", config);

const copyFixedBasePriceSettings = (
  setting: "Opening" | "Filter" | "ExpectedReturn",
  riskProfileId: string,
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/coveredcall/fixedBasePrice/copy${setting}Settings?riskProfileId=${riskProfileId}`,
    {},
  );

export const copyFixedBasePriceOpeningSettings = (riskProfileId: string) =>
  copyFixedBasePriceSettings("Opening", riskProfileId);

export const copyFixedBasePriceFilterSettings = (riskProfileId: string) =>
  copyFixedBasePriceSettings("Filter", riskProfileId);

export const copyFixedBasePriceExpectedReturnSettings = (
  riskProfileId: string,
) => copyFixedBasePriceSettings("ExpectedReturn", riskProfileId);

/**
 * Covered Call
 * نوع جفت
 *
 * @async
 * @version 1.4.0
 */
export const getPairType = (): Promise<any[]> =>
  getRequest("/v1/coveredcall/getPairTypeDropdown");
/**
 * Covered Call
 * گرفتن اسم و آی دی لیست اینپوت بازده انتظاری
 *
 * @async
 * @version 1.4.0
 */
export const getPairType2 = (): Promise<any[]> =>
  getRequest("/v1/coveredcall/getPairTypeDropdown2");

/**
 * Covered Call
 * گرفتن مینیمم مقادیر بازده انتظاری
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getMinProfit = (
  riskProfileId: string,
  useFixedBasePrices = false,
): Promise<IMinProfit[]> =>
  getRequest(
    `/v1/coveredcall/GetMinProfit?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
  );

/**
 * Covered Call
 * ثبت مقادیر جدید بازده انتظاری
 *
 * @param {IMinProfit[]} data
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const setMinProfit = (
  riskProfileId: string,
  config: IMinProfit[],
  useFixedBasePrices = false,
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/coveredcall/SetMinProfit?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
    config,
  );

/**
 * Covered Call
 * حدول های کوچک خرید و فروش در جفت پوزیشن ورود
 *
 * @param {IOrderbooksBody} body
 * @async
 * @version 1.4.0
 */
export const getOrderbook = (body: IOrderbooksBody): Promise<any> =>
  postRequest("/v1/coveredcall/getOrderbook", body);

/**
 * Covered Call
 * دراپ داون نوع پایه
 *
 * @async
 * @version 1.4.0
 */
export const getBaseTypeDropdown = (): Promise<any[]> =>
  getRequest("/v1/coveredcall/getBaseTypeDropdown");

/**
 * Covered Call => EnterPairPosition
 * تنظیمات ورود
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getPairsConfig = (
  riskProfileId: string,
  useFixedBasePrices = false,
): Promise<IPairConfigDto> =>
  getRequest(
    `/v1/coveredcall/getpairsConfig?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
  );

/**
 * Covered Call => roll
 * ثیت تنظیمات
 *
 * @param {IRollConfigDto} data
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const setPairsConfig = (
  config: IPairConfigDto,
  riskProfileId: string,
  useFixedBasePrices = false,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/setpairsConfig?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
    config,
  );

/**
 * Covered Call => EnterPairPosition
 * تنظیمات فیلتر
 *
 * @async
 * @version 1.4.0
 */
export const getFilterSetting = (
  riskProfileId: string,
  useFixedBasePrices = false,
): Promise<IFilterParams> =>
  getRequest(
    `/v1/coveredcall/getDefaultFilterConfig?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
  );

/**
 * Covered Call => EnterPairPosition
 * ثیت فیلتر
 *
 * @param {IFilterParams} data
 * @async
 * @version 1.4.0
 */
export const setFilterSetting = (
  config: IFilterParams,
  riskProfileId: string,
  useFixedBasePrices = false,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/setDefaultFilterConfig?riskProfileId=${riskProfileId}&useFixedBasePrices=${useFixedBasePrices}`,
    config,
  );

/**
 * Covered Call => EnterPairPosition
 *  نمودار
 *
 * @async
 * @version 1.4.0
 */
export const getPairPositionChart = (): Promise<Graph_Dto> => {
  return getRequest(`/v1/coveredcall/GetPairPositionChartData`);
};

/**
 * Covered Call => EnterPairPosition
 *  نمودار بازده ساده روزانه
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getGainAfterCommissionDailyGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    `/v1/coveredcall/GetGainAfterCommissionDailyGraph`,
    params,
  );
};

export const getGainAfterCommissionDailyGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetGainAfterCommissionDailyGraphDaily",
    params,
  );
};

/**
 * Covered Call => EnterPairPosition
 *  نمودار ب ت لحظه ای
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getLivePairPositionGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetLivePairPositionGraph", params);
};

export const getLivePairPositionGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetLivePairPositionGraphDaily", params);
};

/**
 * Covered Call => EnterPairPosition
 *  نمودار ب ت بازده مورد نظر
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getPositionPriceTargetProfitPositionGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetPositionPriceTargetProfitPositionGraph",
    params,
  );
};

//--------------------دامنه نماد--------------------

/**
 * Covered Call => option domain
 * جدول دامنه نماد
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getOptionDomainTable = (
  searchParam: IOptionDomainSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<OptionDomainReport>> =>
  getTable<IOptionDomainSearchParam, OptionDomainReport>(
    "/v1/coveredcall/optiondomain/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => option domain
 * گرفتن کانفیگ نرخ بهره
 *
 * @async
 * @version 1.4.0
 */
export const getOptionDomainConfig = (): Promise<IOptionDomainConfigDto> =>
  getRequest("/v1/coveredcall/optiondomain/getConfig");

/**
 * Covered Call => option domain
 * ثبت کانفیگ نرخ بهره
 *
 * @param {IOptionDomainConfigDto} data
 * @async
 * @version 1.4.0
 */
export const setOptionDomainConfig = (
  config: IOptionDomainConfigDto,
): Promise<Packet<boolean>> =>
  putRequest("/v1/coveredcall/optiondomain/setConfig", config);

/**
 * Covered Call => option domain
 * ویرایش و افزودن
 *
 * @param {IRollConfigDto} data
 * @async
 * @version 1.4.0
 */
export const editOrAddOptionDomain = (
  body: IEditOrAddOptionDomain,
): Promise<Packet<boolean>> =>
  postRequest("/v1/coveredcall/optiondomain/upsert", body);

/**
 * Covered Call => option domain
 * حذف
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const deleteOptionDomain = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/coveredcall/optiondomain/delete?Id=${id}`);

/**
 * Covered Call => option domain
 *  نماد پایه
 *
 * @async
 * @version 1.4.0
 */
export const getBaseOptions = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/coveredCall/getBaseInstruments`);

//-------------محاسبات رول-----------------
/**
 * Covered Call => roll & emergency roll
 *  نماد پایه
 *
 * @async
 * @version 1.4.0
 */
export const getBaseInstruments = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/general/getBaseInstruments`);

/**
 * Covered Call => roll & emergency roll
 *  مبدا و مقصد رول
 *
 * @async
 * @version 1.4.0
 */
export const getOptionInstruments = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/coveredCall/getOptionInstruments`);

/**
 * Covered Call => roll
 * جدول محاسبات رول
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getRollTable = (
  searchParam: IRollSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<RollReport>> =>
  getTable<IRollSearchParam, RollReport>(
    "/v1/coveredcall/roll/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => roll
 * تنظیمات
 *
 * @async
 * @version 1.4.0
 */
export const getRollConfig = (): Promise<IRollConfigDto> =>
  getRequest("/v1/coveredcall/roll/getConfig");

/**
 * Covered Call => roll
 * ثیت تنظیمات
 *
 * @param {IRollConfigDto} data
 * @async
 * @version 1.4.0
 */
export const setRollConfig = (
  config: IRollConfigDto,
): Promise<Packet<boolean>> =>
  putRequest("/v1/coveredcall/roll/setConfig", config);

/**
 * Covered Call => roll
 * دانلود فایل اکسل
 *
 * @param {IRollSearchParam} data
 * @async
 * @version 1.4.0
 */
export const getRollExcel = (searchParam: IRollSearchParam) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/roll/tableExcel?${rand}`,
    searchParam,
  );
};
//---------محاسبات رو به پایین و رو به بالا----------
/**
 * Covered Call => emergency roll
 * تنظیمات رول رو به پایین
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getDownRollConfig = (
  riskProfileId: string,
): Promise<IRollConfigDto> =>
  getRequest(
    `/v1/coveredcall/rolldown/getConfig?riskProfileId=${riskProfileId}`,
  );

/**
 * Covered Call => emergency roll
 * تنظیمات رول رو به بالا
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getUpRollConfig = (
  riskProfileId: string,
): Promise<IRollConfigDto> =>
  getRequest(`/v1/coveredcall/rollup/getConfig?riskProfileId=${riskProfileId}`);

/**
 * Covered Call => emergency roll
 * تنظیمات رول رو به پایین ثبت
 *
 * @param {IRollConfigDto} data
 * @async
 * @version 1.4.0
 */
export const setDownRollConfig = (
  riskProfileId: string,
  config: IRollConfigDto,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/rolldown/setConfig?riskProfileId=${riskProfileId}`,
    config,
  );

/**
 * Covered Call => emergency roll
 * تنظیمات رول رو به بالا ثبت
 *
 * @param {IRollConfigDto} data
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const setUpRollConfig = (
  riskProfileId: string,
  config: IRollConfigDto,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/rollup/setConfig?riskProfileId=${riskProfileId}`,
    config,
  );

/**
 * Covered Call => emergency roll
 * جدول محاسبات رول رو به بالا
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getUpRollTable = (
  searchParam: IRollSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<RollReport>> =>
  getTable<IRollSearchParam, RollReport>(
    "/v1/coveredcall/rollup/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => emergency roll
 * جدول محاسبات رول رو به پایین
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getDownRollTable = (
  searchParam: IRollSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<RollReport>> =>
  getTable<IRollSearchParam, RollReport>(
    "/v1/coveredcall/rolldown/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => roll
 * دانلود فایل اکسل
 *
 * @param {IRollSearchParam} data
 * @async
 * @version 1.4.0
 */
export const getRollDownExcel = (searchParam: IRollSearchParam) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/rolldown/tableExcel?${rand}`,
    searchParam,
  );
};

/**
 * Covered Call => roll
 * دانلود فایل اکسل
 *
 * @param {IRollSearchParam} data
 * @async
 * @version 1.4.0
 */
export const getRollUpExcel = (searchParam: IRollSearchParam) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/rollup/tableExcel?${rand}`,
    searchParam,
  );
};

/**
 * Covered Call => roll
 * تنظیمات فیلتر رول
 *
 * @async
 * @version 1.4.0
 */
export const getRollFilterSetting = (
  position: "up" | "down" | "emergency",
  riskProfileId: string,
): Promise<IRollFilterParams> => {
  switch (position) {
    case "emergency":
      return getRequest(
        `/v1/coveredcall/emergencyRoll/getpreset?riskProfileId=${riskProfileId}`,
      );
    case "up":
      return getRequest(
        `/v1/coveredcall/rollup/getpreset?riskProfileId=${riskProfileId}`,
      );
    case "down":
      return getRequest(
        `/v1/coveredcall/rolldown/getpreset?riskProfileId=${riskProfileId}`,
      );
  }
};

/**
 * Covered Call => EnterPairPosition
 * ثیت فیلتر
 *
 * @param {IRollFilterParams} config
 * @param {string} riskProfileId
 * @param {string} position
 * @async
 * @version 1.4.0
 */
export const setRollFilterSetting = (
  config: IRollFilterParams,
  riskProfileId: string,
  position: "up" | "down" | "emergency",
): Promise<Packet<boolean>> => {
  switch (position) {
    case "emergency":
      return putRequest(
        `/v1/coveredcall/emergencyRoll/setpreset?riskProfileId=${riskProfileId}`,
        config,
      );
    case "up":
      return putRequest(
        `/v1/coveredcall/rollup/setpreset?riskProfileId=${riskProfileId}`,
        config,
      );
    case "down":
      return putRequest(
        `/v1/coveredcall/rolldown/setpreset?riskProfileId=${riskProfileId}`,
        config,
      );
  }
};

//-------------محاسبات رول اضطراری---------
/**
 * Covered Call => emergency roll
 * جدول محاسبات رول
 *
 * @param {IOptionDomainSearchParam} searchParam
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getEmergencyRollTable = (
  searchParam: IRollSearchParam,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<RollReport>> =>
  getTable<IRollSearchParam, RollReport>(
    "/v1/coveredcall/emergencyRoll/table",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => emergency roll
 * تنظیمات
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getEmergencyRollConfig = (
  riskProfileId: string,
): Promise<IRollConfigDto> =>
  getRequest(
    `/v1/coveredcall/emergencyRoll/getConfig?riskProfileId=${riskProfileId}`,
  );

/**
 * Covered Call => emergency roll
 * ثبت کانفیگ نرخ بهره
 *
 * @param {IRollConfigDto} data
 * @async
 * @version 1.4.0
 */
export const setEmergencyRollConfig = (
  riskProfileId: string,
  config: IRollConfigDto,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/emergencyRoll/setConfig?riskProfileId=${riskProfileId}`,
    config,
  );

/**
 * Covered Call => emergency roll
 * دانلود فایل اکسل
 *
 * @param {IRollSearchParam} data
 * @async
 * @version 1.4.0
 */
export const getEmergencyRollExcel = (searchParam: IRollSearchParam) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/emergencyRoll/tableExcel?${rand}`,
    searchParam,
  );
};

/**
 * Covered Call => roll
 *  نمودار
 *
 * @async
 * @version 1.4.0
 */
export const getRollChart = (): Promise<Graph_Dto> => {
  return getRequest(`/v1/coveredcall/GetRollChartData`);
};
/**
 * Covered Call => roll
 *  نمودار در صد بازده روزانه رول
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getRollDailyRollGainGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetRollDailyRollGainGraph", params);
};

export const getCreditAvailabilityGraph = (
  params: ICoveredCallBuyingPowerGraphParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/CreditAvailabilityGraph", params);
};

export const getNonCreditAvailabilityGraph = (
  params: ICoveredCallBuyingPowerGraphParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/NonCreditAvailabilityGraph", params);
};

export const getRollDailyRollGainGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetRollDailyRollGainGraphDaily", params);
};

/**
 * Covered Call => roll
 *  نمودار ب ت رول
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getRollPairPositionGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetRollPairPositionGraph", params);
};

export const getRollPairPositionGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetRollPairPositionGraphDaily", params);
};

export const getRollDailyRollGainCompoundGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetRollDailyRollGainCompoundGraphDaily",
    params,
  );
};

export const getRollDailyRollGainCompoundGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetRollDailyRollGainCompoundGraph",
    params,
  );
};

export const getRollCompundRollTimeDecayGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetRollCompundRollTimeDecayGraphDaily",
    params,
  );
};

export const getRollCompundRollTimeDecayGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GetRollCompundRollTimeDecayGraph",
    params,
  );
};

//--------------------اکانت-------------------

/**
 * Covered Call => accounts
 * جدول اکانت ها
 *
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getAccountTable = (
  searchParam: IAccountsSearchParam,
  offset: number | null,
  pageSize: number | null,
): Promise<Report<AccountsReport>> =>
  getTable<IAccountsSearchParam, AccountsReport>(
    "/v1/coveredcall/accountTable",
    searchParam,
    offset,
    pageSize,
  );

/**
 * Covered Call => accounts
 * ثبت اکانت های جدید
 *
 * @param {IAddUserSearchParams} data
 * @async
 * @version 1.4.0
 */
export const setUserAccount = (
  data: IAddUserSearchParams,
): Promise<Packet<boolean>> => postRequest("/v1/coveredcall/addUser", data);
/**
 * Covered Call => accounts
 * ویرایش اکانت
 *
 * @param {IAddUserSearchParams} data
 * @async
 * @version 1.4.0
 */
export const editUserAccount = (
  data: IAddUserSearchParams,
): Promise<Packet<boolean>> => postRequest("/v1/coveredcall/editUser", data);

/**
 * Covered Call => accounts
 * حذف
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const deleteAccount = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/coveredcall/strategy/delete?id=${id}`);

/**
 * Covered Call => accounts
 * جدول پروفایل ریسک
 *
 * @param {number} offset
 * @param {number} pageSize
 * @param {string} [sortingType]
 * @async
 * @version 1.4.0
 */
export const getRiskProfileTable = (
  searchParam: IProfileRiskSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<ProfileRiskReport>> =>
  getTable<IProfileRiskSearchParams, ProfileRiskReport>(
    "/v1/coveredcall/GetRiskProfileTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

/**
 * Covered Call => accounts
 * ثبت پروفایل ریسک
 *
 * @param {IProfileRisk} params
 * @async
 * @version 1.4.0
 */
export const upsertRiskProfile = (
  params: IProfileRisk,
): Promise<Packet<boolean>> =>
  postRequest("/v1/coveredcall/UpsertRiskProfile", params);

/**
 * Covered Call => accounts
 * حذف پروفایل ریسک
 *
 * @param {number} id
 * @async
 * @version 1.4.0
 */
export const deleteRiskProfile = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/coveredcall/DeleteRiskProfile/${id.toString()}`);

/**
 * Covered Call => option domain
 *  نماد پایه
 *
 * @async
 * @version 1.4.0
 */
export const getRiskProfileDropDown = async (): Promise<Array<DropdownItem>> =>
  getRequest(`/v1/coveredcall/GetRiskProfileDropdown`);

//------------------آفست کاوردکال---------------------

/**
 * Covered Call => Offset
 * دانلود فایل اکسل جفت پوزیشن
 *
 * @param {IEnterPairPositionSearchParams} data
 * @async
 * @version 1.4.0
 */
export const getOffsetExcel = (searchParam: IEnterPairPositionSearchParams) => {
  const rand = Math.random();
  return postDownloadExcel(
    `/v1/coveredcall/coveredCallOffsetExcel?${rand}`,
    searchParam,
  );
};

/**
 *Covered Call => Offset
 * جدول آفست
 *
 * @param {ITabelParams} data
 * @async
 * @version 1.4.0
 */
export const getOffsetTable = (
  searchParam: IEnterPairPositionSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
  additional?: DropdownItem,
  axiosOptions?: AxiosRequestConfig,
): Promise<Report<ICoveredCallOffsetTableReport>> =>
  getTable<IEnterPairPositionSearchParams, ICoveredCallOffsetTableReport>(
    "/v1/coveredcall/coveredCallOffsetTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
    additional,
    axiosOptions,
  );

/**
 * Covered Call => Offset
 * گرفتن مینیمم مقادیر بازده انتظاری
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getMinProfitOffset = (
  riskProfileId: string,
): Promise<IMinProfit[]> =>
  getRequest(
    `/v1/coveredcall/GetMinProfitOffset?riskProfileId=${riskProfileId}`,
  );

/**
 * Covered Call => Offset
 * ثبت مقادیر جدید بازده انتظاری
 *
 * @param {IMinProfit[]} data
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const setMinProfitOffset = (
  riskProfileId: string,
  config: IMinProfit[],
): Promise<Packet<boolean>> =>
  postRequest(
    `/v1/coveredcall/SetMinProfitOffset?riskProfileId=${riskProfileId}`,
    config,
  );

/**
 * Covered Call => Offset
 *  نمودار
 *
 * @async
 * @version 1.4.0
 */
export const getOffsetChart = (): Promise<Graph_Dto> => {
  return getRequest(`/v1/coveredcall/GetOffsetChartData`);
};
/**
 * Covered Call => Offset
 *  نمودار آفست بازده لحظه ای
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getDailyGainOffsetGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetDailyGainOffsetGraph", params);
};

export const getDailyGainOffsetGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetDailyGainOffsetGraphDaily", params);
};
/**
 * Covered Call => Offset
 *  نمودار ب ت آفست لحظه ای
 *
 * @param {IChartCommonSearchParam} params
 * @async
 * @version 1.4.0
 */
export const getPackagePriceGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetPackagePriceGraph", params);
};

export const getPackagePriceGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest("/v1/coveredcall/GetPackagePriceGraphDaily", params);
};

/**
 * Covered Call => Offset
 * نمودار تاریخی روی درصد بازده مرکب سالانه کاوردکال
 *
 * @param {IDailyChartSearchParams} params
 * @async
 * @version 1.4.0
 */
export const getGainAfterCommissionCompoundYearlyGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GainAfterCommissionCompoundYearlyGraphDaily",
    params,
  );
};

export const getGainAfterCommissionCompoundYearlyGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/GainAfterCommissionCompoundYearlyGraph",
    params,
  );
};

export const getTimeValueNetGainYearlyCompoundGraphDaily = (
  params: IDailyChartSearchParams,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/TimeValueNetGainYearlyCompoundGraphDaily",
    params,
  );
};

export const getTimeValueNetGainYearlyCompoundGraph = (
  params: IChartCommonSearchParam,
): Promise<Graph_Dto> => {
  return postRequest(
    "/v1/coveredcall/TimeValueNetGainYearlyCompoundGraph",
    params,
  );
};

/**
 * Covered Call => Offset
 * تنظیمات فیلتر
 *
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const getOffsetFilterSetting = (
  riskProfileId: string,
): Promise<IOffsetFilterParams> =>
  getRequest(
    `/v1/coveredcall/coveredCallOffset/getpreset?riskProfileId=${riskProfileId}`,
  );

/**
 * Covered Call => Offset
 * ثیت فیلتر
 *
 * @param {IRollFilterParams} config
 * @param {string} riskProfileId
 * @async
 * @version 1.4.0
 */
export const setOffsetFilterSetting = (
  config: IOffsetFilterParams,
  riskProfileId: string,
): Promise<Packet<boolean>> =>
  putRequest(
    `/v1/coveredcall/coveredCallOffset/setpreset?riskProfileId=${riskProfileId}`,
    config,
  );
